import React from 'react';
import { styled } from 'styled-components';
import { YouthProtectionInfo } from './YouthProtectionInfo';
import { Colors } from '../../../../play-core/styles/Colors';
import { Device } from '../../../../play-core/styles/Device';
import { zIndex } from '../../../../play-core/styles/z-index';
import { jsx as _jsx } from "react/jsx-runtime";
export const YouthProtectionOverlay = ({
  youthProtectionColor,
  state
}) => {
  if (!youthProtectionColor) return null;
  return /*#__PURE__*/_jsx(YouthProtectionLayout, {
    className: state,
    children: /*#__PURE__*/_jsx(YouthProtectionInfo, {
      youthProtectionColor: youthProtectionColor
    })
  });
};
const {
  youthProtectionOverlayDisplayDuration,
  slideInDelay,
  slideOutDelay
} = {
  youthProtectionOverlayDisplayDuration: 10 * 1000,
  slideInDelay: 10 * 1000,
  slideOutDelay: 3 * 1000
};
export const youthProtectionOverlaySlideInDuration = slideInDelay + youthProtectionOverlayDisplayDuration - slideOutDelay;
const YouthProtectionLayout = styled.div.withConfig({
  displayName: "YouthProtectionOverlay__YouthProtectionLayout",
  componentId: "sc-964w2n-0"
})(["position:absolute;z-index:", ";left:16px;top:56px;right:80px;padding-right:8px;max-width:max-content;border-radius:4px;background-color:", ";color:", ";opacity:0;transition-property:opacity;transition-duration:0.5s;&.slide-in{transition-delay:", "ms;opacity:1;}&.slide-out{transition-delay:", "ms;opacity:0;}", "{top:16px;}"], zIndex.popup, Colors.GREY_aaaaaa, Colors.BLACK, slideInDelay, slideOutDelay, Device.touch);